<template>
  <div class="win_info_container" v-if="show">
    <img class="car_bata_top_element" src="../../../assets/img/secondPhase/car_bata_top_element.png" alt="">
    <img class="btn_close" @click="close()" src="../../../assets/img/secondPhase/btn_close.png" alt="">
    <div class="form_container">
      123{{infoObj}}
    </div>
    <img class="car_bata_bottom_element" src="../../../assets/img/secondPhase/car_bata_bottom_element.png" alt="">
  </div>
</template>
<script>
export default {
  props: {
    infoObj: {
      type: Object
    },
    show: {
      type: Boolean
    },
    openDialog: {
      type: Function,
      default: function (params) {}
    }
  },
  data() {
    return {
      type: true
    }
  },
  methods: {
    close() {
      // this.show = false;
      this.$emit('closeWindow', false)
    }
  }
};
</script>
<style scoped lang="scss">
.win_info_container {
  position: absolute;
  top: 200px;
  left: 650px;
  width: 322px;
  min-height: 338px;
  z-index: 99999;
  background-color: #195D3C;
  opacity: 0.9;
  display: flex;
  flex-direction:column;
  box-shadow: 1px 0px 10px #8fffc9;
  .car_bata_top_element {
    margin-top: -3px;
  }
  .car_bata_bottom_element {
    margin-bottom: -4px;
  }
  .btn_close {
    width: 18px;
    position: absolute;
    right: 0px;
    top: -25px;
    z-index: 999;
  }
  .form_container {
    padding: 10px;
    flex-grow: 1;
    color: #fff;
  }
}
</style>
